"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const do_1 = require("../node/do");
class TwingTokenParserDo extends token_parser_1.TwingTokenParser {
    parse(token) {
        let expr = this.parser.getExpressionParser().parseExpression();
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new do_1.TwingNodeDo(expr, token.getLine(), token.getColumn(), this.getTag());
    }
    getTag() {
        return 'do';
    }
}
exports.TwingTokenParserDo = TwingTokenParserDo;
